import { LocalStorageMapper } from './local-storage.mapper';

export abstract class LocalStorageService<TLocalStorageModel extends { [key: string]: any }> {

  storageModel: TLocalStorageModel = {} as any


  constructor(
    private readonly _mapper: LocalStorageMapper<TLocalStorageModel>
  ) {

  }

  get<K extends Extract<keyof TLocalStorageModel, string>>(key: K): TLocalStorageModel[K] {

    return this.storageModel[key];
  }

  set<K extends Extract<keyof TLocalStorageModel, string>>(key: K, value: TLocalStorageModel[K]) {

    const striginfied = this._stringify(key, value);

    if (!striginfied) {
      window.localStorage.removeItem(key);
      return;
    }

    this.storageModel[key] = value;
    window.localStorage.setItem(key, striginfied);
  }

  remove<K extends Extract<keyof TLocalStorageModel, string>>(key: K) {

    window.localStorage.removeItem(key);
  }

  protected _load() {

    Object.entries(window.localStorage)
      .map(([key, value]) => {
        const typedKey = key as Extract<keyof TLocalStorageModel, string>
        this.storageModel[typedKey] = this._parse(typedKey, value);

      })
  }

  private _parse<K extends Extract<keyof TLocalStorageModel, string>>(key: K, value: string): TLocalStorageModel[K] {
    const mapper = this._mapper[key];

    if (mapper) {
      return mapper.parse(value);
    }

    return value as unknown as TLocalStorageModel[K];
  }

  private _stringify<K extends Extract<keyof TLocalStorageModel, string>>(key: K, value: TLocalStorageModel[K]) {

    if (value === null || value === undefined) {
      return value;
    }

    const mapper = this._mapper[key];


    if (mapper) {
      return mapper.stringify(value);
    }

    if (typeof value === 'object') {
      return JSON.stringify(value);
    }

    if (value) {
      return (<{ toString: () => string }>value).toString();
    }

    return undefined
  }


}
